import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import StatusToast from './StatusToast';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => String(searchParams.get('token') || '').trim(), [searchParams]);
  const { verifyEmail } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleConfirm = async () => {
    setError('');
    setSuccessMessage('');

    if (!token) {
      setError('This confirmation link is invalid. Please request a new one.');
      return;
    }

    setLoading(true);
    const result = await verifyEmail(token);
    if (result.success) {
      setSuccessMessage(result.message || 'Email verified successfully');
    } else {
      setError(result.error || 'Failed to verify email');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Confirm your email</h2>
          <p className="mt-2 text-sm text-gray-600">
            Click the button below to verify your email address.
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-gray-400"
          >
            {loading ? 'Confirming...' : 'Confirm Email Address'}
          </button>

          {successMessage ? (
            <p className="mt-4 text-sm text-green-700 bg-green-50 border border-green-200 rounded-md px-3 py-2">
              {successMessage}
            </p>
          ) : null}

          <p className="mt-6 text-sm text-center text-gray-600">
            <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500">
              Go to sign in
            </Link>
          </p>
        </div>
      </div>

      <StatusToast
        error={error}
        onClearError={() => setError('')}
        bottomOffsetClass="bottom-4"
      />
    </div>
  );
}

export default VerifyEmail;
